import {Injectable} from '@angular/core';
import {BrandingReadiness} from '@screenleads/branding';
@Injectable({providedIn:'root'})
export class BrandingStateService extends BrandingReadiness {}
